import React, { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Form, Button } from "react-bootstrap";
import api from "../../Utils/api";
import Loader from "../../Components/Common/Loader";

const initialFormData = {
  clarityMaster_id: 0,
  clarityMaster_Name: "",
};

export default function ClarityMasterDD({ clarityMasterID }) {
  const [formData, setFormData] = useState(initialFormData);
  const [validated, setValidated] = useState(false);
  const createPartyFormRef = useRef(null);
  const [showLoader, setShowLoader] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const insertOrUpdateClarityMaster = (event) => {
    setShowLoader(true);
    event.preventDefault();
    setValidated(true);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setShowLoader(false);
      return;
    }

    const data = {
      clarityMasterID: formData.clarityMaster_id || 0,
      clarityMasterName: formData.clarityMaster_Name,
    };
    const endpoint =
      formData.clarityMaster_id === 0
        ? "ClarityMaster/InsertClarityMaster"
        : "ClarityMaster/EditClarityMaster";

    const method = formData.clarityMaster_id === 0 ? "post" : "patch";

    api[method](endpoint, data)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message);
          if (clarityMasterID) {
            clarityMasterID(result.data.data);
          }
          resetForm();
        } else {
          toast.error(result.data.message);
        }
      })
      .catch((error) => {
        console.error("Error inserting/updating party master:", error);
        toast.error("An error occurred");
      }).finally(()=>{
        setShowLoader(false);
      })
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setValidated(false);
  };

  return (
    <>
      {showLoader && <Loader />}
      <ToastContainer />
      <Form
        noValidate
        validated={validated}
        onSubmit={insertOrUpdateClarityMaster}
        ref={createPartyFormRef}
      >
        <Row>
          <Col md={6}>
            <div className="col-md-12 d-flex align-items-center mt-4">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <Form.Group controlId="PartyName">
                  <Form.Label style={{ marginRight: "20px" }}>
                    Clarity Name :
                  </Form.Label>
                </Form.Group>
              </div>
              <div className="col-md-8 col-sm-8 col-lg-8">
                <Form.Group controlId="stoneTypeSelect">
                  <Form.Control
                    type="text"
                    name="clarityMaster_Name"
                    placeholder="Enter ClarityName"
                    value={formData.clarityMaster_Name}
                    onChange={handleInputChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter The Value PartyName
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
          </Col>
        </Row>
        <div className="card-footer margin_top10">
          <Button type="submit" variant="primary" className="mb-20px">
            {formData?.clarityMaster_id > 0 ? "Update" : "Save"}
          </Button>
        </div>
      </Form>
    </>
  );
}
